<template>
    <div class="tf" v-show="showTaskFilters">
        <div class="tf__row" v-if="Object.values(filterValues).length">
            <div class="tf__item" v-for="filterValue of Object.values(filterValues)" :key="filterValue.type.type">
                <SelectDropdown
                    v-if="filterValue.type.fieldType == 'select'"
                    :id="`project-filter-${filterValue.type.type}`"
                    :options="filterValue.options"
                    :multiple="filterValue.type.multiple"
                    :field="filterValue.type.type"
                    :value="filterValue.selectedOptions"
                    :title="filterValue.type.title"
                    @change="updateFormData(filterValue.type, $event)"
                />
                <div v-if="filterValue.type.fieldType == 'date'" class="tf__date">
                    <label class="tf__date-label">{{ filterValue.type.title }}</label>
                    <input
                        type="date"
                        class="tf__date-input"
                        :value="filterValue.selectedOptions"
                        @input="updateFormData(filterValue.type, $event.target.value)"
                    />
                </div>
            </div>
            <button class="tf__btn" @click="fetchData" :disabled="fetchingTasks">
                <i :class="fetchingTasks ? 'fas fa-spinner fa-spin' : 'fas fa-search'"></i>
                {{ fetchingTasks ? 'Loading...' : 'Apply' }}
            </button>
        </div>
        <div v-else class="tf__loading">
            <div class="tf__spinner"></div> Loading filters...
        </div>
    </div>
</template>

<script>
import { FILTER_TYPES } from "../../utils/common"
import { mapState, mapActions } from "vuex"
import SelectDropdown from "../crud/SelectDropdown.vue"

export default {
    data() {
        return { FILTER_TYPES, showTaskFilters: false, showTimeout: null }
    },
    components: { SelectDropdown },
    computed: {
        ...mapState("project", ["filterValues", "allProjects", "activeProject", "fetchingTasks"]),
    },
    mounted() {
        this.initTasks()
        this.setShowFilter(true)
    },
    methods: {
        ...mapActions("project", ["initTasks", "fetchTasks", "updateFilters"]),
        fetchData() {
            this.fetchTasks()
        },
        setShowFilter(val) {
            clearTimeout(this.showTimeout)
            this.showTimeout = setTimeout(() => {
                this.showTaskFilters = val
            }, 1000)
        },
        updateFormData(filterType, value) {
            this.updateFilters({ type: filterType, value })
        },
    },
    watch: {
        filterValues(e) {
            if (e && e.length) {
                this.setShowFilter(true)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.tf {
    background: white;
    border: 1px solid $gray100;
    border-radius: 10px;
    padding: 10px 14px;
    margin-bottom: 12px;
    box-shadow: $shadowSm;
    position: relative;
    overflow: visible;
    z-index: 10;
}
.tf__row {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    flex-wrap: wrap;
}
.tf__item {
    flex: 1;
    min-width: 140px;
    max-width: 200px;
    position: relative;
    z-index: 9999;
    &:focus-within { z-index: 10000; }
}
.tf__btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 8px 18px;
    border: none;
    border-radius: 8px;
    background: $primaryColor;
    color: white;
    font-size: 12.5px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: all $transitionFast;
    white-space: nowrap;
    height: 38px;
    flex-shrink: 0;
    &:hover { background: $primaryDark; }
    &:disabled { opacity: .6; cursor: not-allowed; }
    i { font-size: 11px; }
}
.tf__date {
    display: flex;
    flex-direction: column;
}
.tf__date-label {
    font-size: 12px;
    font-weight: 600;
    color: $gray600;
    margin-bottom: 5px;
}
.tf__date-input {
    padding: 7px 10px;
    border: 1px solid $gray200;
    border-radius: 8px;
    font-size: 13px;
    font-family: inherit;
    color: $gray700;
    background: white;
    outline: none;
    height: 38px;
    transition: border-color $transitionFast;
    &:focus { border-color: $primaryColor; box-shadow: 0 0 0 3px rgba($primaryColor, .1); }
}
.tf__loading {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
    font-size: 13px;
    color: $gray400;
}
.tf__spinner {
    width: 16px; height: 16px;
    border: 2px solid $gray200; border-top-color: $primaryColor;
    border-radius: 50%; animation: tfSpin .7s linear infinite;
}
@keyframes tfSpin { to { transform: rotate(360deg); } }
</style>
